import functionUncurryThis from './function-uncurry-this.js';
import requireObjectCoercible$1 from './require-object-coercible.js';
import toString$1 from './to-string.js';

var uncurryThis = functionUncurryThis;
var requireObjectCoercible = requireObjectCoercible$1;
var toString = toString$1;
var quot = /"/g;
var replace = uncurryThis(''.replace); // `CreateHTML` abstract operation
// https://tc39.es/ecma262/#sec-createhtml

var createHtml = function (string, tag, attribute, value) {
  var S = toString(requireObjectCoercible(string));
  var p1 = '<' + tag;
  if (attribute !== '') p1 += ' ' + attribute + '="' + replace(toString(value), quot, '&quot;') + '"';
  return p1 + '>' + S + '</' + tag + '>';
};

export { createHtml as default };
